// extracted by mini-css-extract-plugin
export var container = "_dg-0";
export var popoverContent = "_dg-1";
export var tosLink = "_dg-2";